import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import { Box, Button, CircularProgress, SxProps, Theme, Typography } from '@mui/material';
import { PagePublisherImage } from 'common/interfaces/agg-page';
import { useActions, useAppSelector } from 'hooks';
import { FC, useEffect } from 'react';

import { nativeStyles, styles } from './publisher-archive.styles';

interface IPublisherArchiveProps {
  onImageClick: (item: PagePublisherImage) => void;
  selectedUrls: string[];
}

export const PublisherArchive: FC<IPublisherArchiveProps> = ({ onImageClick, selectedUrls }) => {
  const { fetchPublisherImagesListRequest } = useActions();

  const { loadedPublisherImages, loading, nextPage } = useAppSelector(
    (state) => state.publisherImagesList,
  );

  useEffect(() => {
    if (!loadedPublisherImages?.length) {
      fetchPublisherImagesListRequest({ limit: 20 });
    }
  }, [loadedPublisherImages?.length]);

  return (
    <Box sx={styles.archiveContainer}>
      <Typography color="text.secondary" mb={2} variant="subtitle2">
        Previously Uploaded Images
      </Typography>

      {loading && !loadedPublisherImages?.length && (
        <Box display="flex" justifyContent="center" p={3}>
          <CircularProgress size={30} />
        </Box>
      )}

      <Box display="flex" flexWrap="wrap" gap={2}>
        {loadedPublisherImages?.map((lpi: PagePublisherImage) => {
          const isSelected = selectedUrls.includes(lpi.url || '');
          const item: PagePublisherImage = { ...lpi, type: 'renew' };

          return (
            <Box
              key={lpi.url}
              onClick={() => onImageClick(item)}
              sx={[styles.archiveCard, isSelected && styles.archiveCardSelected] as SxProps<Theme>}
            >
              <img alt="archive" src={lpi.url} style={nativeStyles.imageElement} />
              {isSelected && (
                <Box sx={styles.checkOverlay}>
                  <CheckCircleIcon
                    color="primary"
                    sx={{ fontSize: 32, bgcolor: '#fff', borderRadius: '50%' }}
                  />
                </Box>
              )}
            </Box>
          );
        })}
      </Box>

      {nextPage && (
        <Box display="flex" justifyContent="center" mt={3}>
          <Button
            disabled={loading}
            onClick={() => fetchPublisherImagesListRequest({ page: nextPage })}
            size="small"
            startIcon={loading ? <CircularProgress color="inherit" size={16} /> : null}
            sx={{ minWidth: 120, transition: 'all 0.2s ease-in-out' }}
            variant="outlined"
          >
            {loading ? 'Loading...' : 'Load More'}
          </Button>
        </Box>
      )}
    </Box>
  );
};
